import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.939",
      d: "M11.998 8.623v3.879m0 3.878h.01m9.687-3.878c0 5.355-4.342 9.697-9.697 9.697-5.356 0-9.697-4.342-9.697-9.697 0-5.356 4.341-9.697 9.697-9.697s9.697 4.341 9.697 9.697"
    }, null, -1)
  ]))]))
}
export default { render: render }